(function() {
  angular.module('registration')
  .factory('User', ['$resource', 'registrationUserService', function($resource, registrationUserService) {
    return $resource('users/:userId',{userId:'@userId'},{
      get:  {method: 'GET', isArray: false},
      query:  {method: 'GET', isArray: false},
      save: {method: 'PUT', transformResponse: function(data, headers) {
        registrationUserService.authToken = headers()['x-user-reg-token'];
      }},
      updateEmail: {method: 'POST', url: '/dnUsers/:userId',
        headers: {'x-user-reg-token': registrationUserService.authToken},
      },
      transformResponse: function(data, headers) {
        registrationUserService.authToken = headers()['x-user-reg-token'];
      },
      challengeResponses:  {method: 'GET',url: 'users/:userId/challenges',isArray: false},
      verifyEmail: {method: 'GET', url: '/verifyEmail', isArray: false}
    });
  }])
  .factory('UserEmail', ['$resource', 'registrationUserService', '$log',
  function($resource, registrationUserService, $log) {
    return function() {
      $log.debug('Using ' + registrationUserService.authToken );
      return $resource('dnUsers/:userId',{userId:'@userId'},{
        updateEmail: {method: 'POST',
          headers: {'x-user-reg-token': registrationUserService.authToken},
          transformResponse: function(data, headers) {
            $log.debug('Got ' + registrationUserService.authToken);
            registrationUserService.authToken = headers()['x-user-reg-token'];
          }
        }
      });
    };
  }])
  .factory('Labels', ['$resource',function($resource) {
    return $resource('labels');
  }]);
})();
